import { Route } from 'react-router-dom';
import * as yup from 'yup';

const validators = (__) => () => {
    return (
        yup.object({
            clients: yup.string().required(__(`form.clients.error`)),
            idStartDP: yup.string().required(__(`form.idStartDP.error`)),
            idEndDP: yup.string().required(__(`form.idEndDP.error`)),
            division: yup.string().required(__(`form.division.error`)),
            tonnelage: yup.string().required(__(`form.tonnelage.error`)),
            dateToRoute: yup.string().required(__(`form.dateToRoute.error`)),
            idRouteType: yup.string().required(__(`form.idRouteType.error`)),
        })
    )
}

export default validators
